import React from 'react'
import styled from 'styled-components'

const StyledCardBody = styled.div`
  padding: ${({ theme }) => theme.spacing.large};
`

export const CardBody: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <StyledCardBody>{children}</StyledCardBody>
}
